// Cross-link state for Continuity's admin views — "risk" cards and the
// Directory person page's OKR references both need to jump straight to a
// specific OKR (or a quick filter) on the OKRs tab, and ContinuityHome's
// "people overdue" card needs to land on Conversations pre-filtered. These
// tabs are now separate URL routes (#/continuity/okrs, #/continuity/
// conversations) rather than sibling panels in one shell, so there's no
// parent component left to prop-drill through — a tiny shared state module
// is the smallest way to carry a one-shot "arrive here already filtered"
// intent across a route push. Each flag is consumed once (read + cleared)
// by the destination page's own effect, same lifecycle the old props had.
class ContinuityNavState {
  jumpToOKRId = $state<number | null>(null);
  okrQuickFilter = $state<'red' | 'never_proven' | null>(null);
  peopleOverdueOnly = $state(false);
}

export const continuityNav = new ContinuityNavState();
